// Yes / No / Not Set flags stored as a nullable boolean: null (or missing) = Not Set, never No.
export type TriStateBoolean = boolean | null;

/** A stored or form value as Yes / No / Not Set. Anything but a real boolean is Not Set, never No. */
export function asTriState(value: unknown): TriStateBoolean {
  return typeof value === "boolean" ? value : null;
}

export function triStateToToggleValue(value: TriStateBoolean | undefined): "null" | "true" | "false" {
  if (value === true) return "true";
  if (value === false) return "false";
  return "null";
}

export function toggleValueToTriState(value: string): TriStateBoolean | undefined {
  if (value === "null") return null;
  if (value === "true") return true;
  if (value === "false") return false;
  return undefined;
}

export function triStateLabel(value: TriStateBoolean | undefined): "Yes" | "No" | "Not Set" {
  if (value === true) return "Yes";
  if (value === false) return "No";
  return "Not Set";
}
